import { render, staticRenderFns } from "./newDiscounts.vue?vue&type=template&id=6de98e0c&"
import script from "./newDiscounts.vue?vue&type=script&lang=js&"
export * from "./newDiscounts.vue?vue&type=script&lang=js&"
import style0 from "./newDiscounts.vue?vue&type=style&index=0&id=6de98e0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports